module.exports = __webpack_public_path__ + "img/das-c-2.27e6bd4a.jpg";